import { useState } from "react";
import { ArrowRight, Eye, EyeOff, Loader2 } from "lucide-react";

const inputCls = "h-14 w-full border-b border-bone/25 bg-transparent text-base text-bone outline-none transition-colors placeholder:text-smoke focus:border-acid read-only:text-smoke";

export const Field = ({ label, testid, className = "", ...props }) => (
  <label className={`block ${className}`}>
    <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-smoke">{label}</span>
    <input data-testid={testid} className={inputCls} {...props} />
  </label>
);

export const PasswordField = ({ label, testid, ...props }) => {
  const [show, setShow] = useState(false);
  return (
    <label className="block">
      <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-smoke">{label}</span>
      <span className="relative block">
        <input type={show ? "text" : "password"} data-testid={testid} className={`${inputCls} pr-12`} {...props} />
        <button
          type="button"
          onClick={() => setShow((s) => !s)}
          aria-label={show ? "Nascondi password" : "Mostra password"}
          data-testid={`${testid}-toggle`}
          className="absolute right-0 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center text-smoke transition-colors hover:text-acid"
        >
          {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
        </button>
      </span>
    </label>
  );
};

export const SubmitButton = ({ loading, children, testid, loadingText = "Un attimo…" }) => (
  <button
    type="submit"
    disabled={loading}
    data-testid={testid}
    className="inline-flex h-12 items-center gap-3 rounded-full bg-acid px-7 font-mono text-xs uppercase tracking-[0.18em] text-ink transition-transform duration-300 hover:-translate-y-0.5 active:scale-95 disabled:opacity-60"
  >
    {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
    {loading ? loadingText : children} {!loading && <ArrowRight className="h-4 w-4" />}
  </button>
);

export const FormError = ({ error, testid }) =>
  error ? <p data-testid={testid} className="border-l-2 border-red-400 bg-red-500/10 px-3 py-2 font-mono text-xs text-red-300">{error}</p> : null;
